import { Flex, Title, Text, createStyles, Loader } from "@mantine/core"
import { Image } from "shared/ui/Image"
import React from "react"
import { getImageProps } from "./utils"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  title: {
    [theme.fn.smallerThan("sm")]: {
      fontSize: theme.headings.sizes.h2.fontSize,
    },
  },
}))

// ----------------------------------------------------------------------

type LoadingProps = {
  type: "loading"
}

type OtherProps = {
  type: "error" | "empty"
  message?: string
  title: string
}

export function Result(props: LoadingProps | OtherProps): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Flex direction="column" align="center" justify="center" my={48} sx={{ flex: 1 }}>

      {props.type === "loading" ? (
          <>
            <Loader size="xl" variant="dots"/>
            <Text size="xl" mt="xs">
              Загружаем данные...
            </Text>
          </>
        )
        : (
          <>
            <Image {...getImageProps(props.type)} maw={288} objectFit="contain" px="xl"/>

            <Title align="center" mt="xl" className={classes.title}>
              {props.title}
            </Title>

            {props.message && (
              <Text align="center" c="dimmed" mt="xs">
                {props.message}
              </Text>
            )}
          </>
        )}

    </Flex>
  )
}
